export default function About() {
  return (
    <section
      id="about"
      className="py-28 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6">

        <div className="grid lg:grid-cols-2 gap-20 items-center">

          {/* Image */}

          <div>

            <div className="overflow-hidden rounded-xl shadow-2xl">

              <img
                src="https://placehold.co/700x800"
                alt="About"
                className="w-full h-full object-cover hover:scale-105 transition duration-700"
              />

            </div>

          </div>

          {/* Content */}

          <div className="relative">

            <h2 className="absolute -top-12 left-0 text-[90px] lg:text-[140px] font-black text-gray-100 uppercase select-none">
              About
            </h2>

            <div className="relative">

              <span className="uppercase tracking-[6px] text-red-500 font-semibold">
                About Me
              </span>

              <h3 className="text-5xl font-black mt-4 mb-8">
                Taikhoom Amir
              </h3>

              <p className="text-gray-500 leading-8 mb-10">
                Photography is the science, art and
                practice of creating durable images by
                recording light electronically or by
                means of an image sensor. Every project
                is approached with creativity,
                strategy and attention to detail.
              </p>

              <div className="grid grid-cols-3 gap-10">

                <div>

                  <h4 className="text-5xl font-black">
                    20+
                  </h4>

                  <p className="text-gray-500 mt-2">
                    Years Experience
                  </p>

                </div>

                <div>

                  <h4 className="text-5xl font-black">
                    10+
                  </h4>

                  <p className="text-gray-500 mt-2">
                    Professional Team
                  </p>

                </div>

                <div>

                  <h4 className="text-5xl font-black">
                    2K+
                  </h4>

                  <p className="text-gray-500 mt-2">
                    Done Projects
                  </p>

                </div>

              </div>

              <button className="mt-12 bg-black hover:bg-red-500 transition text-white px-8 py-4 rounded-full">
                Download CV
              </button>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
}